import { Node, RowNode, CellNode } from './Node'
import EditTable from 'slate-edit-table'

export const editTablePlugin = EditTable()

const Plugin = () => ({
  ...editTablePlugin,
  schema: {
    ...editTablePlugin.schema,
    nodes: {
      table: Node,
      table_row: RowNode,
      table_cell: CellNode,
    },
  },
})

export { Plugin as TablePlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Table/index.js